import { api } from './Api';
import {
  ThreadSummaryListETL,
  MessageThreadETL,
} from '../utils/ExtractTransformLoad/MessagingETL';
import { ActiveDriversETL } from '../utils/ExtractTransformLoad/ActiveDriversELT';

// All endpoint paths confirmed against Eatzy API Task #49 docs.
// See .local/eatzy-api-messaging.md for the full API reference.

/**
 * Fetches today's message thread summaries for all drivers.
 * Returns one summary row per driver who has any messages today, newest-first.
 * Endpoint: GET /deliveryops/messages/threads
 */
export const getDriverThreads = async () => {
  const response = await api.get('/deliveryops/messages/threads');
  return ThreadSummaryListETL(response);
};

/**
 * Fetches the full message thread for a specific driver (all-time, not just today).
 * @param {string|number} driverId — the driver's account user ID (roster id field)
 * Endpoint: GET /deliveryops/messages/threads/{driverId}
 */
export const getDriverThread = async (driverId) => {
  const response = await api.get(`/deliveryops/messages/threads/${driverId}`);
  return MessageThreadETL(response);
};

/**
 * Sends a direct message to a single driver.
 * @param {{ driverId: string|number, text: string, type: 'direct' }} payload
 * The API determines delivery method (inApp vs push) based on driver clock-in status.
 * Offline drivers receive a OneSignal push notification automatically.
 * Endpoint: POST /deliveryops/messages
 */
export const sendMessage = async ({ driverId, text, type = 'direct' }) => {
  const response = await api.post('/deliveryops/messages', {
    driver_id: driverId,
    text,
    type,
  });
  return response;
};

/**
 * Batch-marks multiple messages as read in a single request.
 * @param {Array<string|number>} messageIds — thread row IDs (id field from thread detail)
 * Endpoint: PATCH /deliveryops/messages/read  { message_ids: [...] }
 * Response: { marked: true, count: N }
 */
export const markMessagesAsRead = async (messageIds) => {
  const response = await api.patch('/deliveryops/messages/read', {
    message_ids: messageIds,
  });
  return response;
};

/**
 * Fetches the full driver roster (active + inactive / offline drivers included).
 * Endpoint: GET /deliveryops/drivers/roster  (confirmed real — no fallback needed)
 */
export const getDriverRoster = async () => {
  const response = await api.get('/deliveryops/drivers/roster');
  return ActiveDriversETL(response);
};
